module.exports = __webpack_public_path__ + "img/ci-org-v2.6df61346.jpg";